var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarReportIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H9L7 5V9H3V5Z",
    fill: "#231E1E",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1H8L6 5V9H4V5Z",
    fill: "#009A7E",
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarReportIcon);
export default __webpack_public_path__ + "static/media/SideBarReportIcon.18b39ba136c3a631cc7d53f016eab1af.svg";
export { ForwardRef as ReactComponent };